import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { MessageService } from '@app/shared/services/common/message.service';
import { AddressService } from '@app/shared/services/address/address.service';
import { MatDialog } from '@angular/material/dialog';
import { ReleaseLogComponent } from '../../../../shared/components/release-log/release-log.component';
import { CartService } from '../../../end-user/services/cart/cart.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  ProfileimageSrc !: any;
  FullName !: any;
  test: any;
  UserId: any;
  Google_code: any;
  CartItemCount: any;
  cartColor: "#4da185";
  storeId: any;


  constructor(private addressService: AddressService, private router: Router, private loader: LoaderService, private messageService: MessageService, private dialog: MatDialog, private cartservice: CartService) {
    this.messageService.getMessage().subscribe(message => {
      this.FullName = [];
      this.ProfileimageSrc = [];
      //  this.ProfileimageSrc = message[0];
      //  this.FullName = message[1];
      this.ProfileimageSrc = message.message['profileImage'];
      this.FullName = message.message['profileName'];
    });
  }

  ngOnInit() {
    this.UserId = localStorage.getItem('userId');
    this.storeId = localStorage.getItem('storeId');
    this.getStoreAdminCodeById(this.UserId);
    this.FullName = [];
    this.ProfileimageSrc = [];
    this.ProfileimageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
    this.FullName = localStorage.getItem('profileName');
    this.subToService();
    this.fn_GetCartItems();
  }

  subToService() {
    this.messageService.getCartCount().subscribe(res => {
      this.CartItemCount = res.message['cartItemCount'];
      localStorage.setItem('cartItemCount', this.CartItemCount.toString());
    });
  }
  logout() {

    this.loader.show();
    localStorage.clear();
    this.router.navigate(['']);
    this.loader.hide();
  }
  getStoreAdminCodeById(storeAdminId: number) {
    this.addressService.getStoreAdminById(storeAdminId).subscribe((res: any) => {
      // localStorage.setItem('Google_code', res.Data.ResponseData.Google_code);

      this.Google_code = res.Data.ResponseData.Google_code;
      this.test = res.Data.ResponseData.Facebook_pixel;
      $('#google_code').html(this.Google_code);
      $('#facebook_pixel').html(this.test);
    });
  }
  fn_GetCartItems() {
    this.cartservice.GetCartItems(this.UserId, this.storeId).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.CartItemCount = res.Data.ResponseData.length;
        localStorage.setItem('cartItemCount', this.CartItemCount.toString());
      } else {
        this.CartItemCount = 0;
      }
    }, (error: any) => {
      // this.spinner.hide();
      //this.errorhandlerService.handleError(error);
    });
  }
  fn_ShowReleaseLog() {
    localStorage.setItem('IsReleasedLogViewed', "true");
    this.dialog.open(ReleaseLogComponent, {
      disableClose: true,
      width: '80%',
      height: '600px'
    });
  }
}
